import { render, staticRenderFns } from "./displayTableItemDialog.vue?vue&type=template&id=bf6335c8&"
import script from "./displayTableItemDialog.vue?vue&type=script&lang=ts&"
export * from "./displayTableItemDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports